const AMOUNT_PER_PAGE = 25

function getDebounceFunc(func: Function, ms: number): (e: Event) => any {
    let timeout: number | undefined;
    return function later(e: Event): any {
        console.log("GG later");
        if (!timeout) {
            func();
        }
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            console.log('GG reset timeout', timeout)
            timeout = undefined;
            func()
        }, ms);
    };
}

export class InfiniteScroller {
    readonly triggerPoint: number
    private fetchedPages = 0
    private isLastPage = false
    readonly api: Function
    readonly update: Function
    readonly debounceCheck: (e: Event) => any
    readonly targetNode: Element
    readonly amountPerPage: number

    constructor(api: Function, update: Function, el: Element, debounceMs: number, amountPerPage: number = AMOUNT_PER_PAGE, triggerPoint?: number) {
        this.api = api
        this.update = update
        this.triggerPoint = triggerPoint || 600
        this.checkAndFetch = this.checkAndFetch.bind(this)
        this.targetNode = el
        this.amountPerPage = amountPerPage
        this.debounceCheck = getDebounceFunc(() => {
            this.checkAndFetch()
        }, debounceMs)
    }

    start() {
        this.getNextPage()
        this.targetNode.addEventListener('scroll', this.debounceCheck, true)
    }

    stop() {
        this.targetNode.removeEventListener('scroll', this.debounceCheck)
    }

    private getNextPage() {
        console.log('GG getNextPage');
        const PAGE = this.fetchedPages++;

        this.api({PAGE, AMOUNT: this.amountPerPage})
            .then((res: any) => {

                this.isLastPage = this.update(res)
            })
            .catch((e: any) => {

            })
    }

    checkAndFetch() {
        const elem = this.targetNode
        console.log('GG', this.isLastPage)
        if (!this.isLastPage) {
            console.log('GG', elem.scrollHeight - elem.scrollTop - elem.clientHeight)
            if (elem.scrollHeight - elem.scrollTop - elem.clientHeight < this.triggerPoint) {
                this.getNextPage()
            }
        }
    }

}

